import { render, staticRenderFns } from "./FeaturedSearchWrapper.vue?vue&type=template&id=bb52bdcc&"
import script from "./FeaturedSearchWrapper.vue?vue&type=script&lang=js&"
export * from "./FeaturedSearchWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports